import { Record } from "immutable";
import {
    ActiveToolCallNames,
    ToolCallName,
} from "models/enumerations/conversations/tool-call-name";

import { ToolCall } from "models/interfaces/conversations/tool-call";
import { BlockArgumentsRecord } from "./tool-call-arguments/block-arguments-record";
import { BlockArgumentsRecordFactory } from "./tool-call-arguments/block-arguments-record-factory";
import { ToolCallStatusAction } from "models/enumerations/conversations/tool-call-interaction-action";

const defaultValues: ToolCall = {
    id: "",
    arguments: "",
    index: 0,
    name: ToolCallName.BlockSuggest,
    toolCallId: "",
    status: ToolCallStatusAction.Received,
};

export default class ToolCallRecord
    extends Record(defaultValues)
    implements ToolCall
{
    // -----------------------------------------------------------------------------------------
    // #region Constructor
    // -----------------------------------------------------------------------------------------

    constructor(params?: Partial<ToolCall>) {
        if (params == null) {
            params = Object.assign({}, defaultValues);
        }

        super(params as Partial<ToolCall>);
    }

    // #endregion Constructor

    // -----------------------------------------------------------------------------------------
    // #region Public Methods
    // -----------------------------------------------------------------------------------------

    /**
     * Merges new values into the record and returns a new instance.
     *
     * @param {RawMessagePart} values
     */
    public with(values: Partial<ToolCall>): ToolCallRecord {
        return new ToolCallRecord(Object.assign(this.toJS(), values));
    }

    public getArgumentsRecord(): BlockArgumentsRecord {
        return BlockArgumentsRecordFactory(this.arguments);
    }

    public shouldDisplay(): boolean {
        return ActiveToolCallNames.includes(this.name);
    }

    // #endregion Public Methods
}
